<div class="page font-family">
  <div class="header-navigation-back-profile-consent">
    <span class="title">Driver Consent Form</span>
  </div>
  @if (loading) {
    <app-loading-gif></app-loading-gif>
  }
  @if (!loading && !consentProcessed) {
    <div class="content">
      @if (consentData) {
        <div class="consent-success">
          <div class="consent-desciption">
            <p class="consent-desc-text">
              I hereby provide my consent to share my profile information with
              <b>{{ consentData.requesterBehalfOfCompanyName }}</b>
            </p>
          </div>
          <div  class="consent-buttons">
            <button
              mat-button
              (click)="onApproveConsent()"
              data-test="approve-consent-button"
              class="full-width-button btn-approve"
              >
              APPROVE
            </button>
            <button
              mat-button
              (click)="rejectConsent()"
              data-test="reject-consent-button"
              class="full-width-button btn-reject"
              >
              REJECT
            </button>
          </div>
        </div>
      }
      <!-- Show consent failure message if consentData is not available -->
      @if (!consentData) {
        <div class="consent-failure center" >
          <div class="icon-alert">
            <mat-icon svgIcon="alert"></mat-icon>
          </div>
          <p class="error-message">
            {{ consentStatusMessage || genericErrorMessage }}
          </p>
        </div>
      }
    </div>
  }
  <!-- Show success or failure message after processing consent -->
  @if (!loading && consentProcessed) {
    <div
      class="consent-processed-message center"
      >
      <div class="icon-alert">
        <mat-icon svgIcon="tick-blue"></mat-icon>
      </div>
      <p class="success-message center">{{ consentStatusMessage }}</p>
    </div>
  }
</div>
